<template>
    <Select :modelValue="modelValue" :options="options" optionLabel="label" optionValue="value"
        :placeholder="placeholder || 'Select ' + labels.SUBJECT" :class="className" filter showClear @update:modelValue="onUpdate" @change="onChange"
        :loading="loading" />
</template>

<script setup lang="ts">
import { useQuery } from '@vue/apollo-composable';
import gql from 'graphql-tag';
import { useSchoolLabels } from '@/composables/useSchoolLabels';

const { labels } = useSchoolLabels();

const props = defineProps({
  modelValue: {
    type: [String, Number, Object],
    default: null,
  },
  placeholder: {
    type: String,
    default: '',
  },
  className: {
    type: String,
    default: 'w-full',
  },
});

const emit = defineEmits(['update:modelValue', 'change']);

const GET_SUBJECTS = gql`
    query GetSubjects {
        subjects {
            id
            name
        }
    }
`;

const { result, loading } = useQuery(GET_SUBJECTS);

const options = computed(() => result.value?.subjects?.map((s: { id: string; name: string }) => ({
  label: s.name,
  value: s.id,
})) || []);

const onUpdate = (value: string | number | null) => {
  emit('update:modelValue', value);
};

const onChange = (event: Event) => {
  emit('change', event);
};
</script>
